import React, { useMemo } from "react";

import { HighlightWords, escapeRegexp } from "./highlight-words";

export const HighlightText = ({
  value,
  textToHighlight,
  ...props
}: {
  value: string;
  textToHighlight: string;
} & React.ComponentPropsWithoutRef<"span">) => {
  const results = useMemo(
    () =>
      HighlightWords.findAll({
        searchWords: escapeRegexp(textToHighlight || "").split(/\s+/),
        textToHighlight: value,
      }),
    [textToHighlight, value],
  );

  return results.length
    ? results.map((result, index) => {
        const str = value.slice(result.start, result.end);
        return (
          <span
            key={index}
            data-user-value={result.highlight ? true : undefined}
            data-suggested-value={result.highlight ? undefined : true}
            {...props}
          >
            {str}
          </span>
        );
      })
    : value;
};
